import React from 'react';
import cl from './Services.module.css'

import circle from '../../../assets/images/circle.png'

// import weekly from '../../../assets/img/weekly.jpg'
import totalbal2 from '../../../assets/images/totalbal2.png'
import weekly2 from '../../../assets/images/weekly2.png'
import chart from '../../../assets/images/chart.png'

import bussiness_cashimg from '../../../assets/images/bussiness_cashimg.svg'
import bussiness_globusimg from '../../../assets/images/bussiness_globusimg.svg'
import bussiness_backPackImg from '../../../assets/images/bussiness_backPackImg.svg'
import bussines_security from '../../../assets/images/bussines_security.svg'
import arrow_right from '../../../assets/images/arrow_right.svg'
import black_arrow_bottom from '../../../assets/images/black_arrow_bottom.svg'
import light_arrow_left from '../../../assets/images/light_arrow_left.svg'
import arrow_top_black from '../../../assets/images/arrow_top_black.svg'

import cardImg from '../../../assets/images/cardImg.svg'
import flowArrayItem from '../../../assets/images/flowArrow.svg'

import commercialImg from '../../../assets/images/commercial.svg'
import lockImg from '../../../assets/images/lockImg.svg'
import walletImg from '../../../assets/images/wallet.svg'
import chainImg from '../../../assets/images/chain.svg'



import { NavLink } from 'react-router-dom';



const Services = () => {
    return (
        <div className='services_page'>
            <div className={cl.our_services_container}>
                <div className={cl.left_our_services_side}>
                    <h2 className={cl.title_our_services}>
                        Our Services: Simplified, Transparent, and Secure
                    </h2>
                    <p className={cl.description_our_services}>
                        At Fortres BanCorp, we focus on delivering core banking solutions that empower you to manage your money efficiently—without the complexity of loans or credit products. Our offerings are designed for personal users and businesses who value speed, security, and ease of use.
                    </p>
                    <NavLink to='/sign-up'>
                    <div className={cl.btn_our_services}>
                        Open Account
                    </div>
                    </NavLink>
                </div>
                <div className={cl.right_our_services_side}>
                    <img src={circle} alt="" className={cl.main_image}/>
                    <img src={totalbal2} alt="" className={cl.total_balance} />
                    <img src={weekly2} alt="" className={cl.weekly_img}/>
                    <img src={chart} alt="" className={cl.chart_img}/>
                </div>
            </div>
            <div className={cl.global_payments_container}>
                <div className={cl.global_payments_upper}>
                    <h2 className={cl.global_payments_title}>
                        Global Payments & Card Services
                    </h2>
                    <p className={cl.global_payments_descr}>
                        Manage your money worldwide with seamless cards and fully regulated offshore banking.
                    </p>
                </div>
                <div className={cl.global_payments_down_wrapper}>
                   <div className={cl.upper_blocks}>
                        <NavLink to='/services-cards' className={cl.global_payment_item_t}>
                            <div >
                                <div className={cl.payment_header_wrapper}>
                                    <h3 className={cl.payment_title}>
                                        Cards
                                    </h3>
                                    <div className={cl.img_payment_item}>
                                        <img src={cardImg} alt="" />
                                    </div>
                                </div>
                                <div className={cl.payment_item_descr}>
                                    Manage money worldwide with Fortres BanCorp. Seamless global cards, fast and secure payments, fully regulated offshore protection.
                                </div>
                                <div className={cl.payment_item_image}>
                                    <img src={flowArrayItem} alt="" />
                                </div>
                            </div>
                        </NavLink>
                        <NavLink to='/commercial-banking' className={cl.global_payment_item_t}>
                            <div className=''>
                                <div className={cl.payment_header_wrapper}>
                                    <h3 className={cl.payment_title}>
                                        Commercial Banking
                                    </h3>
                                    <div className={cl.img_payment_item}>
                                        <img src={commercialImg} alt="" />
                                    </div>
                                </div>
                                <div className={cl.payment_item_descr}>
                                Global currencies, wires, unified dashboard—plus crypto, custody, trading, and bespoke investments for non-resident entities.
                                </div>
                                <div className={cl.payment_item_image}>
                                    <img src={flowArrayItem} alt="" />
                                </div>
                            </div>
                        </NavLink>
                        <NavLink to='/private-banking' className={cl.global_payment_item_t}>
                        <div className=''>
                            <div className={cl.payment_header_wrapper}>
                                <h3 className={cl.payment_title}>
                                    Private Banking
                                </h3>
                                <div className={cl.img_payment_item}>
                                    <img src={lockImg} alt="" />
                                </div>
                            </div>
                            <div className={cl.payment_item_descr}>
                                Personalized private banking for HNWIs and multi-jurisdictional clients. Bespoke strategies, risk hedging, and selective, asset-backed lending—delivered with flexibility, discretion, and enhanced security.
                            </div>
                            <div className={cl.payment_item_image}>
                                <img src={flowArrayItem} alt="" />
                            </div>
                        </div>
                        </NavLink>
                        
                    </div>
                    <div className={cl.down_blocks}>
                        <NavLink to='/saving-accounts' className={cl.global_payment_item_second}>
                            <div >
                                <div className={cl.payment_header_wrapper}>
                                    <h3 className={cl.payment_title}>
                                        Savings Account
                                    </h3>
                                    <div className={cl.img_payment_item}>
                                        <img src={walletImg} alt="" />
                                    </div>
                                </div>
                                <div className={cl.payment_item_second_descr}>
                                    Open a Fortres BanCorp Savings Account from €500 and earn up to 12% p.a. Enjoy a free debit card, transparent terms, and MISA-backed security for flexible, goal-based saving.
                                </div>
                                <div className={cl.payment_item_image}>
                                    <img src={flowArrayItem} alt="" />
                                </div>
                            </div>
                        </NavLink>
                        <NavLink to='/digital-assets-banking' className={cl.global_payment_item_second}>
                         <div className=''>
                            <div className={cl.payment_header_wrapper}>
                                <h3 className={cl.payment_title}>
                                    Digital Assets Banking
                                </h3>
                                <div className={cl.img_payment_item}>
                                    <img src={chainImg} alt="" />
                                </div>
                            </div>
                            <div className={cl.payment_item_second_descr}>
                                Digital Assets Banking—crypto + fiat under a fully regulated offshore framework. Seamless accounts, payments, and secure custody for startups, enterprises, and HNWIs.
                            </div>
                            <div className={cl.payment_item_image}>
                                <img src={flowArrayItem} alt="" />
                            </div>
                        </div>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className={cl.bussiness_container}>
                <div className={cl.bussines_header_container}>
                    <h3 className={cl.title_bussiness}>
                        <span className={cl.title_bussiness_important}>Everything You Need </span>in a Modern Business Bank
                    </h3>
                </div>
                
                <div className={cl.row_bussiness_items}>
                    <div className={cl.first_bussiness_item}>
                        <div className={cl.img_bussiness_wrapper}>
                            <img src={bussiness_cashimg} alt="#item_image" />
                        </div>
                        <h3 className={cl.bussiness_title}>
                            Digital Accounts
                        </h3>
                        <p className={cl.bussiness_description}>
                             Manage your company’s finances seamlessly. Our platform supports multi-user access, batch payments, and integrates with popular accounting software for streamlined workflows.
                        </p>
                    </div>
                    <div className={cl.second_bussiness_item}>
                        <div className={cl.img_bussiness_wrapper}>
                            <img src={bussiness_globusimg} alt="#bussiness_image" />
                        </div>
                        <h3 className={cl.bussiness_title}>
                            International Payments
                        </h3>
                        <p className={cl.bussiness_description}>
                             Send and receive money globally with transparent fees and real-time foreign exchange rates. Our network covers 190+ countries, enabling you to transact with confidence.
                        </p>
                    </div>
                    <div className={cl.third_bussiness_item}>
                        <div className={cl.img_bussiness_wrapper}>
                            <img src={bussiness_backPackImg} alt="" />
                        </div>
                        <h3 className={cl.bussiness_title}>
                           Business Banking Solutions
                        </h3>
                        <p className={cl.bussiness_description}>
                           Whether you’re a small startup or a large enterprise, we offer flexible, secure, and scalable banking services tailored to meet the unique needs of your business.
                        </p>
                    </div>
                    <div className={cl.four_bussiness_item}>
                        <div className={cl.img_bussiness_wrapper}>
                            <img src={bussines_security} alt="#bussiness_image" />
                        </div>
                        <h3 className={cl.bussiness_title}>
                            Secure Transactions
                        </h3>
                        <p className={cl.bussiness_description}>
                             Your security is our priority. We utilize advanced encryption, two-factor authentication, and continuous monitoring to keep your data and funds safe.
                        </p>
                    </div>
                </div>
            </div>
            <div className={cl.how_it_work_container}>
                <h2 className={cl.how_it_work_title}>
                    How It Works
                </h2>
                <div className={cl.work_items_wrapper}>
                    <div className={cl.work_item}>
                        <h3 className={cl.work_item_title}>
                            1. Easy Account Setup
                        </h3>
                        <div className={cl.work_img_wrapper}>
                            <img src={arrow_right} alt="" />
                        </div>
                        <p className={cl.work_descr}>
                            Complete your digital onboarding quickly with our secure eKYC process—no need for paper forms or branch visits.
                        </p>
                    </div>
                    <div className={[cl.work_item, cl.light_work_item].join(' ')}>
                        <h3 className={cl.work_item_title_light}>
                            2. Manage Your Money
                        </h3>
                        <div className={cl.work_img_wrapper}>
                            <img src={black_arrow_bottom} alt="#arrow_bottom" />
                        </div>
                        <p className={cl.work_descr_light}>
                            Complete your digital onboarding quickly with our secure eKYC process—no need for paper forms or branch visits.
                        </p>
                    </div>
                    <div className={[cl.work_item, cl.light_work_item].join(' ')}>
                        <h3 className={cl.work_item_title_light}>
                           4. Dedicated Support
                        </h3>
                        <div className={cl.work_img_wrapper}>
                            <img src={arrow_top_black} alt="#img_arrow" />
                        </div>
                        <p className={cl.work_descr_light}>
                          Our customer service team is ready to help you anytime, ensuring smooth banking experiences.
                        </p>
                    </div>
                    <div className={cl.work_item}>
                        <h3 className={cl.work_item_title}>
                            3. Global Reach
                        </h3>
                        <div className={cl.work_img_wrapper}>
                            <img src={light_arrow_left} alt="#img_arrow" />
                        </div>
                        <p className={cl.work_descr}>
                           Transfer funds internationally with transparent FX pricing and local delivery options for faster processing.
                        </p>
                    </div>
                </div>
                
            </div>
            
        </div>
    );
};

export default Services;